import { withTranslation } from 'react-i18next';
import ErrorBoundary from './ErrorBoundary';

export default withTranslation('common')(ErrorBoundary);
